import { createSlice } from '@reduxjs/toolkit'

const applications = createSlice({
  name: 'applications',
  initialState: {
    dialogVisible: false,
    openApps: [],
    currentAppId: null
  },
  reducers: {
    setDialogVisibility: (state, action ) => {
      state.dialogVisible = action.payload
    },
    openApplication: ( state, action ) => {

      const opened = state.openApps.filter( app => app.id === action.payload.id )

      if (!opened.length) {
        state.openApps.push(action.payload)
        state.currentAppId = action.payload.id
      } else {
        state.currentAppId = action.payload.id
      }

    },
    closeApplication: (state, action) => {
      state.openApps = state.openApps.filter( app => app.id !== action.payload.id)
      const last = state.openApps.slice(-1).pop()
      state.currentAppId = last ? last.id : null
    },
    setCurrentApp: (state, action ) => {
      state.currentAppId = action.payload
    }
  }
})

export default applications

